<template>
    <div class="wrapper" @click="capture">
        <div class="top-content">
            <div class="top-content-element2" >
                <!-- @click="showMenu" -->
            <!-- <div class="top-content-element"> -->
                <div class="inner-title">Loan Amount(₹)</div>
                <div class="top-content-inner">
                    <span class='tci-amount' v-text="obj.expectBorrowAmount"></span>
                    <!-- <i class="icon icon-white-arrow-up"></i>   -->
                </div>
                <!-- <ul class="amount-list" v-show='list_show'>
                    <li class="amount-element" @click.prevent="selected($event, ind)" :class="{'active': ind === selected_ind}" v-for="(ele, ind) in obj.amountList" :key="ind" v-text="ele"></li>
                </ul> -->
            </div>            
            <div class="top-content-element">
                <div class="inner-title">Repayment Amount</div>
                <div class="top-content-inner small-font" v-text="obj.repaymentAmount"></div>
            </div>
            <div class="top-content-element">
                <div class="inner-title">Interests rate</div>
                <div class="top-content-inner small-font" v-text="obj.interestRate + '%/day'"></div>
            </div>
        </div>  
        <div class="detail-info">
            <ul class="detail-list">                
                <li class="detail-list-element"><span class="left-text">Expect Borrow Amount</span><span class="right-text" v-text="`₹${obj.expectBorrowAmount}`"></span></li>
                <li class="detail-list-element"><span class="left-text">Scheduled Time</span><span class="right-text" v-text="`₹${obj.createTime}`"></span></li>
                <li class="detail-list-element"><span class="left-text">Interest Fee</span><span class="right-text" v-text="`₹${obj.interestFee}`"></span></li>
            </ul>
        </div>    
        <ul class="other-info">
            <li class="oi-element">
                <!-- <router-link :to="`/bank?pid=${$route.params.pid}`" class="alink"> -->
                    <div class="left-content">
                        <h4 class="oi-title">Bank Account</h4>
                        <div class="oi-content" :class="{'no-choice': !bank_info.have_bank}" v-text="bank_info.have_bank? bank_info.card_no : 'Click To Select Bankcard'"></div>                        
                    </div>
                <!-- </router-link> -->
            </li>
        </ul>
        <p class="caption">
            
        </p>
        <div class="btn-container">
            <a class="btn-submit" @click.prevent="confirm_show = true">Cancel</a>
        </div>
        <div class="btn-container-placeholder"></div>
        <div class="dialog-wrapper" v-show="confirm_show">
            <div class="dialog-confirm">
                <div class="dialog-title">Info</div>                
                <div class="dialog-content">
                    Are you confirm cancel this schedule order ?
                </div>
                <div class="dialog-footer">
                    <a href="javascript:void(0);" class="btn-submit" @click.prevent="submit">Yes</a>
                    <a href="javascript:void(0);" class="btn-cancel" @click.prevent="confirm_show = false">No</a>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="less" scoped>
@import "assets/less/icon.less";
    .dialog-wrapper{
        position: fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        width: 100%;
        height: 100%;
        background:rgba(0,0,0,0.8);
        .dialog-confirm{           
            width: 500px;
            margin:0 auto;
            background:#fff;
            border-radius: 15px;
            position:absolute;
            left:50%;
            top:50%;
            transform: translate(-50%, -50%);
            padding:50px 80px;
            .dialog-title{
                font-size: 44px;
                text-align:center;
                color:#58987B;
                margin-bottom: 50px;
                font-weight: 700;
            }
            .dialog-content{
                font-size: 32px;
                color:#151515;
                word-break: break-all;
                line-height: 1.5;
            }
            .dialog-footer{
                width: 100%;
                margin-top: 80px;
                .btn-submit{
                    display:block;
                    width: 500px;
                    height: 96px;
                    background: #58987B;
                    border-radius: 12px;
                    color: #FFFFFF;
                    text-align: center;
                    line-height: 96px;
                    font-size: 32px;
                    margin:0 auto;
                }
                .btn-cancel{
                    display: block;
                    width: 500px;
                    text-align: center;
                    font-size: 30px;
                    color:#58987B;
                    padding:30px 0;
                    margin:0 auto;
                }
            }
        }
    }
.auto{
    width: 590px;
    padding:40px;
    height: 136px;
    background: linear-gradient(180deg, #fff 0%, #EFEEF8 100%);
    border-radius: 20px;
    margin:30px auto;
    position:relative;
    .auto-content{        
        .auto-title{
            color:#58987B;
            font-weight: 700;
            margin-bottom: 30px;
            font-size: 28px;
        }
        .auto-text{
            font-size: 24px;
            color:#58987B;
            line-height: 1.5;
            font-weight: 300;
        }
    }
}
.btn-container-placeholder{
    height: 100px;
}
.choice-container{  
        // display: none;      
        position: absolute;
        width: 575px;
        padding:0 30px;      
        background:#fff; 
        z-index:99; 
        box-shadow: 0px 0px 44px 0px rgba(9, 14, 118, 0.08);
        top:250px;        
        .choice-element{            
            border-bottom: 2px solid #EFEEF1;
            padding:40px;            
            color:#000;
            font-size: 32px;
            &.active{
                color:#58987B;
            }
        }
    }
.other-info{
    
    .oi-element{
        padding:40px;
        border-bottom: 2px solid #EFEEF1;
        overflow: hidden; 
        .alink{
            display:block;
            width: 100%;
            height: 100%;
        }       
        .left-content{
            float:left;
            .oi-title{
                color:#A59BB3;
                font-size: 26px;
            }
            .oi-content{
                font-size: 30px;
                color:#000;
                margin-top: 30px;
                &.no-choice{
                    color:#D0CDDA;
                }
            }
        }
        .right-content{
            float:right;
            position: relative;
            margin-top: 40px;
        }
    }
}
.wrapper{
    padding: 50px;    
    .top-content{
        position:relative;
        width: 564px;
        height: 240px;
        background:url("~assets/images/product_bg.png") no-repeat;
        background-size: 100% 100%;
        padding:40px; 
        // overflow:hidden;
        .top-content-element2{
            width: 100%;
            margin-bottom: 30px;
            .inner-title{
                color:#D9CCFF;
                font-size: 24px;
                margin-bottom: 15px;
                width: 100%;
                text-align: center;
            }
            .top-content-inner{
                color:#fff;
                font-size: 64px;
                font-weight: 700;
                position:relative;
                align-items: center;
                justify-content: center;
                width: 100%;
                text-align:center;
                .tci-amount{
                    
                }
                .icon{
                    position:absolute;
                    top:20px;
                    right:100px;
                }
                // text-align: center;
            }
        }
        .top-content-element{
            width:50%;
            float:left;
            margin-bottom: 60px;
            .inner-title{
                color:#D9CCFF;
                font-size: 24px;
                margin-bottom: 15px;
            }
            .top-content-inner{
                color:#fff;
                font-size: 64px;
                font-weight: 700;
                display: flex;
                align-items: center;
            }
            .small-font{
                font-size: 48px;
            }
            
        }       

    }
    .detail-info{
        background:#F5F4FA;
        padding:40px 40px 10px 40px;
        width: 564px;
        margin-top: -10px;
        border-radius: 0 0 20px 20px;
        .detail-list{
            clear: both;
            .detail-list-element{
                // overflow:hidden;
                margin-bottom: 30px;
                height:30px;
                .left-text{
                   float:left;
                   color:#A59BB3;
                   font-size: 28px; 
                }
                .right-text{
                    float:right;
                    color:#A59BB3;
                    font-size: 28px;
                }
            }
        }
    }
    .btn-container{
        position:fixed;
        bottom:50px;
        left:10px;
        width: 100%;
        height: 96px;
        .btn-submit{
            display: block;
            width: 670px;
            height: 96px;
            line-height: 96px;
            text-align: center;
            border-radius: 12px;
            background:#58987B;
            font-size: 32px;
            margin:0 auto;
            color:#fff;
        }
    }
    .amount-list{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        background:rgba(255,255,255,1);
        border-radius: 15px;;
        z-index: 99999;
        padding:0 30px;
        .amount-element{
            text-align:center;
            width: 150px;
            padding:30px;
            color:#A59BB3;
            font-size: 28px;   
            border-bottom: 2px solid #e0e0e0;   
            &:last-child{
                border-bottom: none;
            }      
            &:hover{
                color:#58987B;
                border-bottom-color:#e0e0e0;   
            }
        }
        
    }
}
</style>
<script>
import {  calculate, getBank, autoDetail, productInfo, cancelAuto} from '@api/index'
import { onMounted,reactive,ref } from 'vue'
import {useRouter} from 'vue-router'
import { useLoading } from 'vue-loading-overlay'
// import { getAnalytics, logEvent } from 'firebase/analytics'
export default {
    setup () {                
        const router = useRouter()
        const route = router.currentRoute        
        const $loader = useLoading()
        const clicked = ref(false)
        const list_show = ref(false)
        const selected_ind = ref(0)
        // const proxy  = getCurrentInstance().proxy
        const confirm_show = ref(false)
        // const analytics = getAnalytics()
        // const addressGetState = ref(0)
        let useage_info = reactive({
            choices:['Shopping','Medical treatment','Education','Tourism','Living expenses','Purchase of vehicles'],
            selected_ind: null,
            value:"",
            is_show:false
        })
        let obj = reactive({
            amountList:[],
            selectAmount:'',
            serviceRate:'',
            interestRate: '',
            processFee:'',
            gstFee:'',
            interestFee:'',
            period: '',
            expectBorrowAmount: "",
            createTime:"",
            orderNo:""
        })
        let bank_info = reactive({
            card_no:'',
            bank_id:'',
            have_bank:''
        })                
        onMounted(async ()=>{
            const loader = $loader.show({
                container:null
            })                

            productInfo({
                id: route.value.query.pid
            }).then(data => {
                loader.hide()
                obj.amountList = data.data.amountList
                obj.period = data.data.period
                obj.selectAmount = data.data.amountList[data.data.amountList.length - 1]
                selected_ind.value = data.data.amountList.length - 1
                obj.interestRate = data.data.interestRate
                
            })
            
            autoDetail(route.value.params.oid).then( res => {
                if(res.code == 0) {
                    obj.expectBorrowAmount = res.data.expectBorrowAmount
                    obj.createTime = res.data.createTime
                    obj.orderNo = res.data.orderNo
                    bank_info.bank_id = res.data.cardId
                    calculate({
                        productId: route.value.query.pid, 
                        amount: obj.expectBorrowAmount,
                        period: 7
                    }).then(data2=>{
                        obj.repaymentAmount = data2.data.repaymentAmount
                        obj.interestFee = data2.data.interest
                    })

                    getBank({
                        productId:route.value.query.pid
                    }).then(data3 => {
                        if(data3.code == 0) {
                            if(data3.data.length > 0) {
                                if(bank_info.bank_id.length) {
                                    const target = data3.data.filter((ele)=>{
                                        return ele.id == bank_info.bank_id
                                    })
                                    bank_info.card_no = target[0].cardNo
                                    bank_info.bank_id = target[0].id
                                    
                                } else {
                                    bank_info.card_no = data3.data[0].cardNo
                                    bank_info.bank_id = data3.data[0].id                        
                                }
                                bank_info.have_bank = true
                            } else {
                                bank_info.have_bank = false
                            }
                        }
                    })
                }
            })
            
            
            
                        
                        
        })        
        const submit = async () => {                                                 
              if(clicked.value)return 
              clicked.value = true   
              
              cancelAuto({
                id:route.value.params.oid,
                orderNo: obj.orderNo
              }).then(res => {
                if(res.code == 0) {
                    router.replace({
                        path:"/schedule"
                    })
                }
              })
              
        }
        const capture = () => {
            list_show.value = false
        }
        const selected = async (e, ind) => {
            e.stopPropagation()
            obj.selectAmount = obj.amountList[ind]
            selected_ind.value = ind
            list_show.value = false
            const data2 = await calculate({
               productId: route.value.params.pid, 
               amount: obj.selectAmount,
               period: 7
            })            
            obj.repaymentAmount = data2.data.repaymentAmount
            obj.processFee = data2.data.serviceFee
            obj.gstFee = data2.data.gstFee
            obj.interestFee = data2.data.interest
        }
        const showUseage = () => {
            useage_info.is_show = true
        }
        const useage_selected = (e,ind) => {
            e.stopPropagation()            
            useage_info.selected_ind = ind 
            useage_info.is_show = false
            useage_info.value = ind
        }        
        return {
            obj, 
            selected_ind,           
            list_show,
            bank_info,
            useage_info,
            confirm_show,
            showUseage,
            submit,
            capture,
            selected,
            useage_selected,
        }
    }
}
</script>